export enum TEAM_TYPE {
  stay = 'A103_01',
  store = 'A103_02',
}

export enum STATUS_TS {
  active = 'A105_01',
  notActive = 'A105_02',
}

export enum STATUS_NAME_ST {
  ACTIVE = 'Hoạt động',
  DEACTIVE = 'Không hoạt động',
}

export interface IParams {
  query: string;
  variables?: any;
}

export interface DataTeamSales {
  test: any; //ko được để obj rỗng
}

export interface IParamsCreate {
  id: string;
  name?: string;
  subId?: string;
  plantId: string;
  teamTypeId?: TEAM_TYPE;
  salesTeamCode?: string;
  isWork?: boolean;
  createId: string;
  createDate: string;
  employees: string[] | TteamSalesDetail[];
  leaderId: string;
  teamCapacity: number;
  endDate: string;
  sloc: string;
  record?: any;
  typeId?: string;
  manageId?: string;
}

// export interface IParamsUpdate extends IParamsCreate {
//   id: string;
// }

export type IParamsUpdate = Omit<
  IParamsCreate,
  'createId' | 'createDate' | 'employees' | 'leaderId'
> & {
  id: string;
  modifyId: string;
  modifyDate: string;
  employees: TteamSalesDetail[];
  currentEmployees: TteamSalesDetail[];
  isLeaderChange: boolean;
  leaderId?: string;
  useYn?: boolean;
  newEmployees?: TteamSalesDetail[];
  oldEmployees?: TteamSalesDetail[];
};

export interface GetUserNotTS {
  pageInfo: PageInfo;
  items: UserNotTS[];
}

export interface UserNotTS extends User {
  isWorking: boolean;
  role: string;
  activeRoute: boolean;
}

export interface GetTeamSales {
  pageInfo: PageInfo;
  items: Item[];
}

export interface Item {
  id: string;
  name: string;
  isWork: boolean;
  plantId: string;
  salesTeamCode: null | string;
  teamTypeId: string;
  createDate: null;
  useYn: boolean;
  createId: null | string;
  teamCapacity: null;
  sloc: null | string;
  endDate: null;
  tstatus: TStatus;
  statusName: string;
  tplant: Tplant | null;
  tcreateUser: TcreateUser | null;
  tteamType: TteamType;
  trevenuePlanTteamsales: any[];
  tsalesPlannings: TsalesPlanning[];
  tteamSalesDetails: TteamSalesDetail[];
}

export interface TcreateUser {
  id: string;
  fullName: string;
}

export interface Tplant {
  id: string;
  name: string;
}

export type TStatus = Tplant;

export interface TsalesPlanning {
  id: string;
  name: string;
  plantId: string;
  expectedRevenue: null;
  implementationDate: null;
  saleEndDate: Date;
  saleStartedDate: Date;
  teamSales: TeamSales;
  createDate: null;
  approvalDate: null;
}

export interface TeamSales {
  id: string;
  name: string;
  isWork: boolean;
  plantId: string;
  salesTeamCode: null | string;
  createDate: null;
  useYn: boolean;
}

export interface TteamSalesDetail {
  id: string;
  sloc: null | string;
  startDate: null;
  endDate: null;
  userId: string;
  user: User;
  useYn: boolean;
  leaderYn: boolean;
}

export interface User {
  id: string;
  fullName: string;
  avatar: null | string;
  email: string;
  phoneNumber: null;
  sloc: null | string;
}

export interface TteamType {
  id: string;
  name: string;
  note: string;
}

export interface PageInfo {
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
}

export interface IDataCustomerTS {
  id: string;
  custId: string;
  teamSalesId: string;
  indexNum: number;
  useYn: boolean;
  tcustomer: Tcustomer;
  tteamSale: TteamSale;
}

export interface Tcustomer {
  id: string;
  storeName: string;
  address: null;
  phone: string;
  trank: Trank;
  tdistrict: null;
  tward: null;
  tcity: null;
}

interface Trank {
  name: string;
}

interface TteamSale {
  id: string;
  name: string;
}

export interface IFilterTeamSale {
  id?: string;
  tteamSalesDetails?: TteamSalesDetails | string;
  plantId?: string;
  teamTypeId?: string;
  statusId?: string;
  page?: number;
  pageSize?: number;
  idOrName?: string;
}

export interface IFilterTeamSaleCb {
  value?: string;
  pageSize?: number;
  plantId?: string;
  useYn?: boolean;
  managerId?: string;
  userId?: string;
}

export interface ID {
  equals: string;
}

export interface TteamSalesDetails {
  userId: ID;
  useYn: UseYn;
}

export interface UseYn {
  equals: boolean;
}

export interface IGetAllComboBox {
  page?: number;
  pageSize?: number;
}

export interface IGetAllById {
  teamSalesId: string;
  tcustomer?: string;
  page?: number;
  pageSize?: number;
  isExport?: boolean;
}

export interface IGetTeamSaleDetailById {
  page?: number;
  pageSize?: number;
  teamSaleId: string;
  user?: string;
  useYn?: boolean;
}

export interface IAddCustomerInTeamRoute {
  routeId: string;
  teamId: string;
  custId: string;
}

export interface IGetUserByPlantNotTeamSale {
  plantId?: string;
  notInTeamSale?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
}

export interface IGetSlocByPlant {
  plantId: string;
  searchValue?: string;
  page: number;
  pageSize: number;
}

export interface ISloc {
  id: string;
  plantId: string;
}

export interface IGetUserSaleInCombobox {
  plantId?: string;
  pageSize: number;
  page: number;
  email?: string;
}

export interface IGetAllFilterTeamSales {
  page?: number;
  pageSize?: number;
  plantId?: string;
  teamSaleId?: string;
  teamTypeId?: string;
  statusId?: string;
  userId?: string;
  idOrName?: string;
  managerId?: string;
}

export interface ICheckValidSaleTeam {
  id: string;
}

export interface IGetValidTeamSaleById {
  teamSaleId: string;
  isWork?: boolean;
}

export interface IGetAllTeamSaleByPlant {
  skip: number;
  take: number;
  plantId: string;
  search?: string;
}

export interface IGetAllRouteByTeamSaleInPlant {
  skip: number;
  take: number;
  plantId: string;
  teamSalesId: string;
  search?: string;
}

export interface IGetUserByPlantEmail {
  plantCode: string;
  email: string;
}

export interface IGetManagerCombobox {
  searchValue?: string;
  plantId: string;
  pageSize?: number;
}

export interface ITeamManager {
  id: string;
  fullName: string;
  email: string;
  role: string;
  plantCode: string;
}
